import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { credentialsIsComplete, meetInfoIsComplete, rosterEntriesIsComplete, submitIsComplete } from './LeftNavValidation';

const getSubmit = (viewName, route, omeMeetOrgUnitEntryInfoStateObjData, omeMeetOrgUnitEntryRosterPermissionsStateObjData) => {
  const isCurrent = ((viewName === Views.OME_MEET_SUBMIT) || (viewName === Views.OME_MEET_SUBMITTED)) === true ? true : false;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetOrgUnitEntryInfoStateObjData, omeMeetOrgUnitEntryRosterPermissionsStateObjData);
  const isRosterEntriesComplete = rosterEntriesIsComplete(omeMeetOrgUnitEntryInfoStateObjData);
  const isCredentialsComplete = credentialsIsComplete(omeMeetOrgUnitEntryInfoStateObjData);

  const arePrerequisitesDone = isMeetInfoComplete === true && isRosterEntriesComplete === true && isCredentialsComplete === true;

  const isComplete = isMeetInfoComplete === true && isRosterEntriesComplete === true && isCredentialsComplete === true && submitIsComplete();

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_SUBMIT) : getInitialStateMeetRoute(Views.OME_MEET_SUBMIT);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getSubmit;